export default [
    '36 36',
    '<path fill="none" d="M13.5 4.5H22.5M4.5 9H31.5M28.5 9L27.4481 24.7789C27.2902 27.1463 27.2113 28.33 26.7 29.2275C26.2499 30.0177 25.5709 30.6529 24.7525 31.0495C23.823 31.5 22.6366 31.5 20.264 31.5H15.736C13.3634 31.5 12.177 31.5 11.2475 31.0495C10.4291 30.6529 9.75013 30.0177 9.29997 29.2275C8.78867 28.33 8.70975 27.1463 8.55193 24.7789L7.5 9M15 15.75V23.25M21 15.75V23.25" stroke="url(#paint0_linear_1302_774)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<defs>\n' +
    '<linearGradient id="paint0_linear_1302_774" x1="31.5" y1="18.0207" x2="4.5" y2="18.0207" gradientUnits="userSpaceOnUse">\n' +
    '<stop stop-color="var(--p-icon-gradient-stop, currentColor)"/>\n' +
    '<stop offset="1" stop-color="var(--p-icon-gradient-start, currentColor)"/>\n' +
    '</linearGradient>\n' +
    '</defs>'
]